import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'src/app/services/app/app.service';
import { AddBankDetailComponent } from '../add-bank-detail/add-bank-detail.component';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from 'src/app/services/common/common.service';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';
import { Category, SubCategory } from 'src/app/model/employees';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-add-job-preference',
  templateUrl: './add-job-preference.component.html',
  styleUrls: ['./add-job-preference.component.scss']
})
export class AddJobPreferenceComponent {
  public addForm!:FormGroup;
  public employeeId!:string;
  public categoryArr:Category[]=[]
  public subCategoryArr:SubCategory[]=[]
  dropdownSettings: IDropdownSettings = {};
  constructor(private fb:FormBuilder,private appService:AppService,private dialogRef:MatDialogRef<AddJobPreferenceComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any, private datePipe: DatePipe,
    private commonService:CommonService, private spinner:NgxSpinnerService,private recruiterService:RecruiterService,
  ){}

  ngOnInit(): void {
    this.dropdownSettings = {
			idField: 'j_sc',
			textField: 'j_sc',
			allowSearchFilter: true
		};
    this.addForm=this.fb.group({
      j_c:["",Validators.required],
      jc_id:[""],
      j_sc:["",Validators.required],
      j_sc_id:[""],
      add:["",Validators.required],
      s_pw:["",Validators.required],
      w_tt:[""],
      int_ft:[""],
      un_mi:[""]
      // // ac_hn:["",Validators.required],
      // ac_n:["",Validators.required],
      // b_n:["",Validators.required],
      // ib_n:["",Validators.required],
      // pps_n:["",Validators.required],
      // s_c:["",Validators.required],
      // b_add:["",Validators.required],
    })

    if(this.dialogData){
      this.employeeId=this.dialogData
      this.getCategory()
    }
   
  }
  isControlHasError(controlName: string, validationType: string): boolean {
    return this.appService.isControlHasError( this.addForm,controlName, validationType);
  }
  getCategory(){
    // let obj = {
    //   em_i:this.employeeId
    // }
    this.recruiterService.getCategoryList({}).subscribe({
      next: (success: any) => {
        this.categoryArr=[];
        this.subCategoryArr=[];
        if(success.msg){
          this.categoryArr=success.msg;
        }

      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onSelectCategory(event){
    let catItem = this.categoryArr.find((item)=>item.j_c==event.value);
    this.addForm.get('jc_id')?.setValue(catItem?.id);
    this.addForm.get('j_sc')?.setValue('');
    this.subCategoryArr=[];
    if(catItem){
      this.subCategoryArr=catItem.sub_category;
    } 
  }
  onSelectSubCategory(event){
    let value=event.value;
    let item=this.subCategoryArr?.find((item)=>item.j_sc==value)
    this.addForm.get('j_sc_id')?.setValue(item?.id)
  }

  onCancel(){
    this.dialogRef.close()
  }
  onSubmit(){
    if(this.addForm.valid==false){
      this.addForm.markAllAsTouched()
      return
    }
    let obj=this.addForm.value;
    obj["em_i"]=this.employeeId
    const newArr: { j_sc: string }[] = JSON.parse(JSON.stringify(this.addForm.get('j_sc')?.value));
    // Map and join the values
    const joinedString = newArr.map(item => item.j_sc).join(',');
    // Assign the joined string to obj["j_sc"]
    obj["j_sc"] = joinedString;
    let newSubCat :any[]=[]
   
    for (let i=0;i<this.subCategoryArr.length;i++){
     if(joinedString.includes(this.subCategoryArr[i].j_sc)){
      newSubCat.push(this.subCategoryArr[i].jc_id)
     }
    }
    obj["j_sc_id"]=newSubCat;
    this.recruiterService.addProfile(obj).subscribe({
      next: (success: any) => {
        //this.spinner.hide()
       this.appService.showToastMessage('success',success.msg);
       this.dialogRef.close({data_added:true})
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  
}
